import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-436abf30")
const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_2 = { class: "random-input" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "random-title" }, "抽取学生数", -1)
const _hoisted_4 = { class: "random-select" }
const _hoisted_5 = { class: "random-select-num" }
const _hoisted_6 = { class: "random-list" }
const _hoisted_7 = { class: "random-list-btn-wrapper" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "check-box-label" }, "全选", -1)
_popScopeId()

import { ref, PropType, computed, inject } from "vue";
import { useStore } from "vuex";
import BaseModal from "../base/BaseModal.vue";
import { ClassroomInterationNS } from "../../types";
import StudentCard from "../base/StudentCard.vue";
import { ElMessage } from "element-plus";
import { addStudentEvaluateRecord } from "@/services/classroomInteraction";
import logger from "@evideo/logger";
import { delayLoading } from "../../utils";
import { reportStat } from "@/utils/statDataReport";


export default _defineComponent({
  props: {
  visible: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
  list: {
    type: Array as PropType<ClassroomInterationNS.StudentInfo[]>,
    default: () => [],
  },
  lessonId: {
    type: Number as PropType<number>,
  },
  curSubject: {
    type: String as PropType<string>,
    default: "music",
  },
},
  emits: ["update:visible", "onOk", "onCancel"] as unknown as undefined,
  setup(__props, { emit }: { emit: ({
  (event: "update:visible", newValue: boolean): void;
  (event: "onOk", value: any): void;
  (event: "onCancel"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




const store = useStore();

const visibleCompu = computed<boolean>(() => props.visible);
const showHeaderBackground = ref<boolean>(false);
const len = computed<number>(() => props.list.length);
const maxNum = computed(() => (len.value - 1 > 0 ? len.value - 1 : 0));
const stuList = ref<ClassroomInterationNS.StudentInfo[]>(props.list);

const selectNum = ref<number>(1);

const allSelect = computed(() => {
  let flag = true;
  randomList.value.forEach((i) => {
    if (!selectKeySet.value.has(i.id)) {
      flag = false;
    }
  });
  return flag;
});

const selectKeySet = ref(new Set());

const lessonId = computed(() => props.lessonId);
const curSubject = computed(() => props.curSubject);

// 动画效果相关
const animationtionInfo = ref<{ visible: boolean; score: number }>({
  visible: false,
  score: 1,
});

const handleShowAppraiseModal =
  inject<ClassroomInterationNS.handleShowAppraiseModalProvider>(
    "handleShowAppraiseModal"
  );
// 更新学生信息列表
const handleUpdateStudentList = inject<() => Promise<void>>(
  "handleUpdateStudentList"
);

// 随机结果展示
const randomList = ref<ClassroomInterationNS.StudentInfo[]>([]);

// 是否展示随机结果
const showRandomResult = ref<boolean>(false);
// body元素节点
const CIBodyRef: any = inject("CIBodyRef");

// 加
const handleAdd = () => {
  if (selectNum.value < maxNum.value) {
    selectNum.value++;
  }
};

// 减
const handleReduce = () => {
  if (selectNum.value > 1) {
    selectNum.value--;
  }
};

const randomNumList = (num: number, max: number): number[] => {
  const keySet = new Set<number>();
  const allKey = [];
  for (let i = 0; i < max; i++) {
    allKey.push(i);
  }
  while (keySet.size < num) {
    // 随机生成一个1000 以内的步长
    let step = Math.ceil(Math.random() * 1000) % allKey.length;
    keySet.add(allKey[step]);
    allKey.splice(step, 1);
  }

  return Array.from(keySet);
};

// 随机抽选学生
const handleRandomClick = () => {
  console.log("开始随机抽选");
  if (stuList.value.length < 1) {
    ElMessage.error("班级学生数量为0,无法使用随机功能");
    return;
  }
  const indexs = randomNumList(selectNum.value, len.value);
  const list: ClassroomInterationNS.StudentInfo[] = [];
  indexs.forEach((index: number) => {
    list.push(stuList.value[index]);
  });
  randomList.value = list;
  showRandomResult.value = true;
  showHeaderBackground.value = true;
};

const handleGoBackRandom = () => {
  showRandomResult.value = false;
  showHeaderBackground.value = false;
  selectKeySet.value.clear();
  randomList.value = [];
};

const handleSelectAll = () => {
  if (selectKeySet.value.size !== randomList.value.length) {
    randomList.value.forEach((i) => {
      selectKeySet.value.add(i.id);
    });
  } else {
    selectKeySet.value.clear();
  }
};

// 点击卡片
const handleClickStuCard = (item: ClassroomInterationNS.StudentInfo) => {
  console.log(item);
  const { id } = item;
  if (id) {
    selectKeySet.value.has(id)
      ? selectKeySet.value.delete(id)
      : selectKeySet.value.add(id);
  }
};

const handleEvaluationSelectOk = async (ids: any[], evaluationValue: any) => {
  const students: any[] = [];
  const stuMap = new Map();
  randomList.value.forEach((i) => {
    stuMap.set(i.id, i);
  });

  ids.forEach((i: number | string) => {
    const stu = stuMap.get(i);
    if (stu) {
      students.push({
        student_id: stu.id,
        score: parseInt(evaluationValue.single_opr_score),
      });
    }
  });
  const params = {
    lesson_id: lessonId.value,
    norm_code: evaluationValue.norm_code,
    subject: curSubject.value || "music",
    students,
  };
  let clearFunc = undefined;
  try {
    clearFunc = delayLoading(1000, "点评中，请稍后...");
    await addStudentEvaluateRecord(params);
    // 数据埋点
    reportStat({
      moduleid: "tools",
      pageid: "classCommunication",
      eventid: "classCommunication_studentEvaluation",
      eventattr: {
        teacher_id: store.state.teacherId,
        result: students,
      },
    });
    clearFunc();
    if (handleUpdateStudentList) {
      handleUpdateStudentList();
    }
    animationtionInfo.value = {
      score: parseInt(evaluationValue.single_opr_score),
      visible: true,
    };
    // 一秒后自自动消失加分动画
    let key = setTimeout(() => {
      animationtionInfo.value.visible = false;
      animationtionInfo.value.score = 1;
      clearTimeout(key);
    }, 1000);
  } catch (err) {
    if (clearFunc) {
      clearFunc();
      clearFunc = undefined;
    }
    ElMessage.error("点评失败,请重试");
    logger.error("课堂评价随机抽取学生评价失败");
  }
};

// 展示点评
const handleShowEvaluation = async () => {
  console.log("发送点评");
  if (selectKeySet.value.size < 1) {
    ElMessage.error("请至少选择一个学生");
    return;
  }
  let name = "";
  const ids = Array.from(selectKeySet.value);
  const index: any = ids[0];
  const search = randomList.value.filter((i) => i.id === index);
  if (search.length < 1) {
    return;
  } else {
    name = search[0].name + "等";
  }

  const info = {
    msg: name,
    autoClose: true,
  };
  const onOk = async (val: any) => await handleEvaluationSelectOk(ids, val);
  if (handleShowAppraiseModal) {
    handleShowAppraiseModal(info, onOk);
  }
};

const handleClose = () => {
  emit("update:visible", false);
};

// 将节点挂载到body
const setBodyRef = () => CIBodyRef.value;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "body-style": {
      width: '43.9rem',
      height: '30.9rem',
    },
    visible: _unref(visibleCompu),
    "show-header-background": showHeaderBackground.value,
    onOnClose: handleClose,
    getContainer: setBodyRef
  }, {
    title: _withCtx(() => [
      (showHeaderBackground.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "随机抽选"))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["random-select-reduce", { 'random-add-max': selectNum.value == 1 }]),
            onClick: handleReduce
          }, " - ", 2),
          _createElementVNode("div", _hoisted_5, _toDisplayString(selectNum.value), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["random-select-reduce", { 'random-add-max': selectNum.value >= _unref(maxNum) }]),
            onClick: handleAdd
          }, " + ", 2)
        ]),
        _createElementVNode("div", { class: "random-btn-wrapper" }, [
          _createElementVNode("div", {
            class: "random-btn",
            onClick: handleRandomClick
          }, "确定")
        ])
      ], 512), [
        [_vShow, !showRandomResult.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(randomList.value, (item) => {
          return (_openBlock(), _createBlock(StudentCard, {
            class: "random-item",
            key: item.id,
            info: item,
            "score-animation": {
          ...animationtionInfo.value,
          visible: selectKeySet.value.has(item.id) && animationtionInfo.value.visible,
        },
            "is-select": selectKeySet.value.has(item.id),
            onClick: () => handleClickStuCard(item)
          }, null, 8, ["info", "score-animation", "is-select", "onClick"]))
        }), 128)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "all-select",
            onClick: handleSelectAll
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["check-box", _unref(allSelect) ? 'check-box-select' : 'check-box-no-select'])
            }, null, 2),
            _hoisted_8
          ]),
          _createElementVNode("div", { class: "btn-wrapper" }, [
            _createElementVNode("div", {
              class: "random-again-btn",
              onClick: handleGoBackRandom
            }, " 重新抽选 "),
            _createElementVNode("div", {
              class: "send-btn",
              onClick: handleShowEvaluation
            }, "发送点评")
          ])
        ])
      ], 512), [
        [_vShow, showRandomResult.value]
      ])
    ]),
    _: 1
  }, 8, ["body-style", "visible", "show-header-background"]))
}
}

})